import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";
const productLinks = [{
  label: "iOS 下载",
  href: "#"
}, {
  label: "Android 下载",
  href: "#"
}, {
  label: "Windows 客户端",
  href: "#"
}, {
  label: "macOS 客户端",
  href: "#"
}];
const resourceLinks = [{
  label: "下载中心",
  href: "/DownloadCenterPage"
}, {
  label: "在线应用",
  href: "/OnlineAppPage"
}, {
  label: "深度解析",
  href: "/DeepAnalysisPage"
}, {
  label: "意见反馈",
  href: "/FeedbackPage"
}];
const legalLinks = [{
  label: "隐私政策",
  href: "/PrivacyPolicyPage"
}, {
  label: "用户协议",
  href: "#"
}, {
  label: "联系邮箱",
  href: "#"
}];
export default function FooterInformation() {
  return <section data-section-id="90898" id="页脚信息" className="bg-muted/30 text-foreground py-16 px-6 md:px-12 border-t border-border">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 mb-16">
          {}
          <div className="flex flex-col items-start">
            <Link to="#" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618423/img/you_music_logo_footer_no_bg.png" alt="听力通" className="h-9 w-auto object-contain mb-4" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-[200px]">
              听不懂英语？一句一句练到听懂。AI 赋能的智能英语听力训练系统。
            </p>
          </div>

          {}
          <div>
            <h3 className="text-slate-900 font-bold mb-6 text-sm tracking-widest uppercase">
              软件下载
            </h3>
            <ul className="space-y-4">
              {productLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-sm text-slate-500 hover:text-primary font-medium transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-slate-900 font-bold mb-6 text-sm tracking-widest uppercase">
              快速导航
            </h3>
            <ul className="space-y-4">
              {resourceLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-sm text-slate-500 hover:text-primary font-medium transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-slate-900 font-bold mb-6 text-sm tracking-widest uppercase">
              法律与联系
            </h3>
            <ul className="space-y-4">
              {legalLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-sm text-slate-500 hover:text-primary font-medium transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <Separator className="bg-border mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-400 font-medium">
            &copy; {new Date().getFullYear()} 听力通. 保留所有权利。
          </p>
          <Badge variant="secondary" className="bg-primary/10 text-primary hover:bg-primary/20 border border-primary/20 transition-colors px-4 py-1 rounded-full font-bold">
            AI 赋能学习
          </Badge>
        </div>
      </div>
    </section>;
}